<template>
  <el-dialog :visible.sync="visible" width="280px" @close="dialogClose">
    <el-input
      type="textarea"
      :rows="4"
      maxlength="60"
      placeholder="请输入内容"
      v-model="value"
      resize="none"
      autofocus
    ></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleDialogConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      value: '',
      visible: false
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    blankValue: {
      type: String,
      default: ''
    }
  },
  watch: {
    blankValue: {
      immediate: true,
      handler(val) {
        this.value = val
      }
    },
    dialogVisible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.value = this.blankValue
          })
        }
        this.visible = val
      }
    }
  },
  methods: {
    handleDialogConfirm() {
      this.$emit('confirm', this.value)
    },
    dialogClose(val) {
      this.$emit('confirm', this.value)
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/queDialog.vue